import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';

import { selectAuthMessage, selectDealerData, selectLoggedInUserDataId, selectSearchFetchingResults} from 'src/app/common/store/state/app.state';
import { Dealer } from 'src/app/public/account/models/dealer.model';

@Component({
    selector: 'app-dealer-myowners',
    templateUrl: './dealer-myowners.component.html',
    styleUrls: ['./dealer-myowners.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DealerMyOwnersComponent implements OnInit{

  myDealerData$: Observable<Dealer>;
  authFeedback$: Observable<string>;

  currentUserId$: Observable<string>;
  currentUserId: string = "";

  fetchingResults$: Observable<boolean>;

  dealerData: Dealer = new Dealer();

  constructor(
    private store: Store, 
    private router: Router,
    private route: ActivatedRoute) {

      this.currentUserId$ = this.store.select(selectLoggedInUserDataId);

      this.myDealerData$ = this.store.select(selectDealerData);
      this.authFeedback$ = store.select(selectAuthMessage);

      this.fetchingResults$ = store.select(selectSearchFetchingResults);
   
    }
  
  ngOnInit(): void {

    this.currentUserId$.subscribe( (userId: string) => {
      this.currentUserId = userId;
      this.store.dispatch(DealerActions.fetchMyOwnersSubmit());
      
    }
    );

    this.myDealerData$.subscribe( (dealerData: Dealer) => {
      this.dealerData = dealerData;
      }
    );
  }
  
  goToProviderSearch(): void{

    this.router.navigate(
        ['/owner/search-provider'],
        { queryParams: {  } }
      );

  }
}
